export const triggerGA = (data) => {
  if (typeof dataLayer !== 'undefined') {
    data.event = data.event || 'default_action';
    // eslint-disable-next-line no-undef
    dataLayer.push(data);
  }
};
